import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
  Box,
  Flex,
} from "@chakra-ui/react";
import { AlertTriangle } from "lucide-react";

interface ChannelMismatchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  t: (key: string) => string;
  mismatchedChannels: string[];
}

export const ChannelMismatchModal: React.FC<ChannelMismatchModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  t,
  mismatchedChannels,
}) => {
  const getChannelLabel = (channel: string) => {
    const labels: Record<string, string> = {
      whatsapp: "WhatsApp",
      email: "Email",
      push_notification: "App",
    };
    return labels[channel] || channel;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent bg="white">
        <ModalHeader borderBottomWidth="1px" pb={4}>
          <Flex align="center" gap={3}>
            <Box>
              <AlertTriangle size={24} color="#F59E0B" />
            </Box>
            <Text fontSize="lg" fontWeight="600" color="#242E38">
              {t("channelMismatchWarning")}
            </Text>
          </Flex>
        </ModalHeader>

        <ModalBody py={6}>
          <VStack align="start" spacing={5}>
            <Text color="#242E38" fontSize="md">
              {t("someUsersDoNotHaveVerifiedChannels")}
            </Text>

            <Box w="100%">
              <Text fontWeight="500" mb={3} color="#242E38">
                {t("selectedChannelsNotVerified")}:
              </Text>
              <Flex gap={2} flexWrap="wrap">
                {mismatchedChannels.map((channel) => (
                  <Box
                    key={channel}
                    px={3}
                    py={1.5}
                    bg="#FEF3C7"
                    borderRadius="md"
                    fontSize="sm"
                    fontWeight="500"
                    color="#92400E"
                  >
                    {getChannelLabel(channel)}
                  </Box>
                ))}
              </Flex>
            </Box>

            <Text fontSize="sm" color="#242E38" lineHeight="1.6">
              {t("usersWithoutChannelWillNotReceiveNotifications")}
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter borderTopWidth="1px" bg="white" gap={3}>
          <Button variant="ghost" color="newBlue.500" onClick={onClose}>
            {t("goBack")}
          </Button>
          <Button
            layerStyle="ocean"
            _hover={{ layerStyle: "ocean" }}
            onClick={onConfirm}
          >
            {t("saveAnyway")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
